// search box autocomplete
import autoComplete from "@tarekraafat/autocomplete.js";
const inputBox2 = document.querySelector(
    ".homepage-search input#autoComplete2"
);
const doc = document.querySelector("body");
if (inputBox2) {
    const autoCompleteJS = new autoComplete({
        data: {
            src: async (query) => {
                try {
                    // Fetch Data from external Source
                    const source = await fetch(
                        `${autoCompleteJS.input.getAttribute(
                            "data-autocomplete-endpoint"
                        )}&partial_query=${query}`
                    );
                    const data = await source.json();

                    data.map((e) => {
                        e.title = e.disp.title;
                        e.url = e.disp.displayUrl;
                        e.summary = e.disp.summary;
                    });
                    return data;
                } catch (error) {
                    return error;
                }
            },
            keys: ["title"],
            cache: false,
        },
        selector: "#autoComplete2",
        resultsList: {
            tag: "div",
            class: "autocomplete-results",
            destination: ".homepage-search",
            position: "beforeend",
            maxResults: 5,
            tabSelect: true,
            noResults: true,
            element: (list, data) => {
                const message = document.createElement("p");
                message.setAttribute("class", "suggested-pages");
                message.innerHTML = `Suggested Pages`;
                list.prepend(message);
                if (!data.results.length) {
                    const message = document.createElement("div");
                    message.setAttribute("class", "no_result");
                    message.innerHTML = `<p>No results for <b>${data.query}</b></p>`;
                    list.append(message);
                }
            },
        },
        resultItem: {
            tag: "a",
            class: "autoComplete_result",
            element: (item, data) => {
                item.setAttribute("href", data.value.url);
                item.innerHTML = `
               <b>${data.value.title}</b>
               <p>${data.value.summary}</p>
               `;
            },
            highlight: "autoComplete_highlight",
            selected: "autoComplete_selected",
        },
        wrapper: false,
        submit: true,
        trigger: (query) => {
            if (query.replace(/ /g, "").length > 2) {
                document
                    .querySelector(".homepage-search form.input-form")
                    .classList.add("active");
                document
                    .querySelector(".homepage-search div.autocomplete-results")
                    .removeAttribute("hidden");
            } else {
                document
                    .querySelector(".homepage-search form.input-form")
                    .classList.remove("active");
                document
                    .querySelector(".homepage-search div.autocomplete-results")
                    .setAttribute("hidden", "");
            }

            return query.replace(/ /g, "").length > 2; // Returns "Boolean"
        },
        events: {
            input: {
                keyup: (event) => {
                    if (event.key === "Escape") {
                        document
                            .querySelector(".homepage-search form.input-form")
                            .classList.remove("active");
                    }
                },
            },
        },
    });

    // to remove class from inputBox2 when click makes autocomplete disappear
    doc.addEventListener("click", function () {
        document
            .querySelector(".homepage-search form.input-form")
            .classList.remove("active");
        document
            .querySelector(".homepage-search div.autocomplete-results")
            .setAttribute("hidden", "");
    });
}

// input clear button
const clearBtn2 = document.querySelector(".homepage-search div#clear-text-btn");
if (clearBtn2) {
    clearBtn2.addEventListener("click", () => {
        inputBox2.value = "";
        document
            .querySelector(".homepage-search form.input-form")
            .classList.remove("active");
        document
            .querySelector(".homepage-search div.autocomplete-results")
            .setAttribute("hidden", "");
    });
}
